import { AllViewsLink } from './AllViewsLink';
import { jsx as _jsx } from "react/jsx-runtime";
export const DefaultPinnedViewsBarAllViewsLink = ({
  objectTypeId,
  namespace
}) => {
  return /*#__PURE__*/_jsx(AllViewsLink, {
    returnLink: window.location.toString(),
    objectTypeId: objectTypeId,
    namespace: namespace
  });
};